"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const TileGroupRedirectButton = React.memo(({ redirectUrl, checkAllBtnLabel }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center mt-2xl mb-5xl", children: (0, jsx_runtime_1.jsx)("a", { href: redirectUrl, className: "cta-secondary btn-large w-full sm:w-auto no-underline", children: (0, jsx_runtime_1.jsx)("span", { className: "text-nowrap", children: checkAllBtnLabel }) }) }));
});
exports.default = TileGroupRedirectButton;
